module.exports = __webpack_public_path__ + "static/media/icon_113.8102c307.svg";